<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12" class="mx-0 px-0">
                <template>
                    <v-data-table
                        :headers="headers"
                        :items="teams"
                        class="stats-table no-global-table-hover elevation-1 rounded-lg"
                        hide-default-footer
                        :mobile-breakpoint="0"
                        :items-per-page="-1"
                        @click:row="goToTeam"
                    >
                        <template v-slot:item.name="{ item }">
                            <div class="entity-cell">
                                <span v-if="item.logo" class="entity-cell__thumb">
                                    <img :src="`${assetsUrl}/${item.logo}`" alt="">
                                </span>
                                <span class="entity-cell__name">{{ item.name }}</span>
                            </div>
                        </template>
                        <template v-slot:item.two_points_percentage="{ item }">
                            <span class="font-weight-bold"> {{ option ? `${item.two_points_percentage}% (${item.cum.twoPointsMade} / ${item.cum.twoPointAttempts})` : `${item.two_points_percentage}%` }} </span>
                        </template>
                        <template v-slot:item.three_points_percentage="{ item }">
                            <span class="font-weight-bold"> {{ option ? `${item.three_points_percentage}% (${item.cum.threePointsMade} / ${item.cum.threePointAttempts})` : `${item.three_points_percentage}%` }} </span>
                        </template>
                        <template v-slot:item.free_throw_percentage="{ item }">
                            <span class="font-weight-bold"> {{ option ? `${item.free_throw_percentage}% (${item.cum.freeThrowsMade} / ${item.cum.freeThrowAttempts})` : `${item.free_throw_percentage}%` }} </span>
                        </template>
                    </v-data-table>
                </template>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            teams: {
                type: Array,
                default: null
            },
            option: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                headers: [
                    { text: 'Team', value: 'name', align: 'start' },
                    { text: 'GP', value: 'gp', align: 'center' },
                    { text: 'Pts', value: 'points', align: 'center' },
                    { text: '2P%', value: 'two_points_percentage', width: '150px', align: 'center' },
                    { text: '3P%', value: 'three_points_percentage', width: '150px', align: 'center' },
                    { text: 'FT%', value: 'free_throw_percentage', width: '150px', align: 'center' },
                    { text: 'OR', value: 'offensiveRebounds', align: 'center' },
                    { text: 'DR', value: 'defensiveRebounds', align: 'center' },
                    { text: 'TR', value: 'rebounds', align: 'center' },
                    { text: 'AST', value: 'assists', align: 'center' },
                    { text: 'AST PTS', value: 'assistPoints', align: 'center' },
                    { text: '2CH PTS', value: 'secondChancePoints', align: 'center' },
                    { text: 'PTS OFF TO', value: 'pointsOffTurnovers', align: 'center' },
                    { text: 'STL', value: 'steals', align: 'center' },
                    { text: 'TO', value: 'turnovers', align: 'center' },
                    { text: 'BLK', value: 'blockedShots', align: 'center' },
                    { text: 'FC', value: 'fouls', align: 'center' }
                ]
            }
        },
        watch: {
            option: {
                handler() {
                    this.prepareData()
                }
            },
            teams: {
                handler() {
                    this.prepareData()
                }
            }
        },
        created() {
            if (this.generic) {
                this.headers = [{ text: 'Team', value: 'team' }, ...this.headers]
            }
            this.prepareData()
        },
        methods: {
            getTeamId(team) {
                return team.id || team.teamId || (team.team ? team.team.id : null)
            },
            goToTeam(team) {
                const teamId = this.getTeamId(team)
                if (!teamId) {
                    return
                }
                this.$router.push({ name: 'Team', params: { id: teamId } })
            },
            prepareData() {
                this.teams.forEach(team => {
                    team.points = this.option ? team.cum.points : team.avg.points.toFixed(1)
                    team.gp = team.stats.length
                    team.two_points_percentage = this.option ? (team.cum.twoPointsMade / (team.cum.twoPointAttempts ? team.cum.twoPointAttempts : 1) * 100).toFixed(1) : (team.avg.twoPointsMade / (team.avg.twoPointAttempts ? team.avg.twoPointAttempts : 1) * 100).toFixed(1)
                    team.free_throw_percentage = this.option ? (team.cum.freeThrowsMade / (team.cum.freeThrowAttempts ? team.cum.freeThrowAttempts : 1) * 100).toFixed(1) : (team.avg.freeThrowsMade / (team.avg.freeThrowAttempts ? team.avg.freeThrowAttempts : 1) * 100).toFixed(1)
                    team.three_points_percentage = this.option ? (team.cum.threePointsMade / (team.cum.threePointAttempts ? team.cum.threePointAttempts : 1) * 100).toFixed(1) : (team.avg.threePointsMade / (team.avg.threePointAttempts ? team.avg.threePointAttempts : 1) * 100).toFixed(1)
                    team.offensiveRebounds = this.option ? team.cum.offensiveRebounds : team.avg.offensiveRebounds.toFixed(1)
                    team.defensiveRebounds = this.option ? team.cum.defensiveRebounds : team.avg.defensiveRebounds.toFixed(1)
                    team.rebounds = this.option ? team.cum.rebounds : team.avg.rebounds.toFixed(1)
                    team.assists = this.option ? team.cum.assists : team.avg.assists.toFixed(1)
                    team.assistPoints = this.option ? team.cum.assistPoints : team.avg.assistPoints.toFixed(1)
                    team.secondChancePoints = this.option ? team.cum.secondChancePoints : team.avg.secondChancePoints.toFixed(1)
                    team.pointsOffTurnovers = this.option ? team.cum.pointsOffTurnovers : team.avg.pointsOffTurnovers.toFixed(1)
                    team.steals = this.option ? team.cum.steals : team.avg.steals.toFixed(1)
                    team.turnovers = this.option ? team.cum.turnovers : team.avg.turnovers.toFixed(1)
                    team.blockedShots = this.option ? team.cum.blockedShots : team.avg.blockedShots.toFixed(1)
                    // every foul: personal, technical and unsportsmanlike
                    team.fouls = this.option ? team.cum.fouls : team.avg.fouls.toFixed(1)
                })
            }
        }
    }
</script>

<style scoped>
/* ---------- Same look as the standings table ---------- */
.stats-table {
    overflow: hidden;
    font-family: Ubuntu, Arial, sans-serif;
}

.stats-table ::v-deep .v-data-table__wrapper table > thead > tr > th {
    background: #0d0d0f !important;
    color: #fff !important;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    white-space: nowrap;
    border-bottom: 3px solid #ff7133 !important;
}

.stats-table ::v-deep .v-data-table__wrapper table > thead > tr > th .v-icon {
    color: #fff !important;
}

.stats-table ::v-deep .v-data-table__wrapper table > tbody > tr > td {
    height: 52px;
    white-space: nowrap;
    background: #fff;
}

.stats-table ::v-deep .v-data-table__wrapper table > tbody > tr:nth-child(even) > td {
    background: #f7f7f8 !important;
}

.stats-table ::v-deep .v-data-table__wrapper table > tbody > tr:hover > td {
    background: #fff3ec !important;
}

.stats-table ::v-deep .v-data-table__wrapper table > tbody > tr:hover > td:first-child {
    box-shadow: inset 4px 0 0 #ff7133;
}

.stats-table ::v-deep tbody tr {
    cursor: pointer;
}

.entity-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.entity-cell__thumb {
    display: inline-flex;
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
    padding: 2px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.entity-cell__thumb img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.entity-cell__name {
    font-weight: 700;
    white-space: normal;
    line-height: 1.2;
}
</style>
